import { parser } from '@/utils/parser'

export const state = () => ({
  events: [],
  meta: null,
  pending: false
})

export const mutations = {
  clear: (state) => {
    state.events = []
    state.meta = null
  },
  setEvents: (state, events) => state.events = [...state.events, ...events],
  setMeta: (state, meta) => state.meta = meta,
  setPending: (state, pending) => state.pending = pending
}

export const actions = {
  async fetch ({ commit }, payload) {
    commit('setPending', true)
    if (payload?.clear) {
      commit('clear')
    }
    const events = await this.$axios.$get(`/api/events?${parser(payload)}`)
    commit('setEvents', events.data)
    commit('setMeta', events.meta)
    commit('setPending', false)
  }
}

export const getters = {
  events: state => state.events,
  meta: state => state.meta,
  pending: state => state.pending
}
